import { createFileRoute, redirect } from '@tanstack/react-router';
import { hasLedgerSelfScope, useAuthStore } from '@/lib/auth';
import { MY_PROFILE_TABS } from '../../-constants';
export const Route = createFileRoute('/_individual/individual/_profile/my-profile/_layout/')({
  // インデックス着地時は「最初の可視タブ」へ直接寄せる。台帳 self の可否を見て
  // リダイレクト先を決めることで、certification/self を持たないユーザーで発生していた
  // 二段リダイレクト（index → certification タブ → MyProfileLayout の Navigate）を防ぐ。
  // 「最初のタブ」の定義は MY_PROFILE_TABS の並び順に一本化する（ハードコードしない）。
  beforeLoad: () => {
    const dataScopes = useAuthStore.getState().session?.dataScopes ?? [];
    const firstVisibleTab = MY_PROFILE_TABS.find(tab => hasLedgerSelfScope(dataScopes, tab.ledger));
    // 可視タブが無い（全台帳 self が無効）→ 個人トップへ退避する（MyProfileLayout と同じ挙動）。
    throw redirect({
      to: firstVisibleTab?.to ?? '/individual'
    });
  }
});